module.exports = __webpack_public_path__ + "img/default_img.6a59eeb4.png";